import { API } from "../../../utils/api";

export const getDashboard = async (query) => {
  const res = await API.get(`dashboard`, query);
  return res.data;
};
